import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, ViewChild } from '@angular/core'
import { MatMenuTrigger } from '@angular/material/menu'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { ActivatedRoute, Params, Router } from '@angular/router'
// import { AlertService } from '@app/alert/service/alert.service'
// import { ModalService } from '@app/modal/modal.service'
import { merge } from 'rxjs'
import { map, startWith, switchMap } from 'rxjs/operators'
import { FormacaoDuracaoService } from '../formacao-duracao-service'
import { FormacaoDuracaoModel } from '@shared/models/backend'

@Component({
  selector: 'app-formacao-duracao-table',
  templateUrl: './formacao-duracao-table.component.html',
  styleUrls: ['./formacao-duracao-table.component.scss'],
})
export class FormacaoDuracaoTableComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger

  filterChange: EventEmitter<string> = new EventEmitter()
  dataSource = new MatTableDataSource()
  displayedColumns = []
  resultsLength = 0
  isLoadingResults = false

  private currentFilter: Params

  constructor(
    private activeRoute: ActivatedRoute,
    private changeDetector: ChangeDetectorRef,
    private router: Router,
    // private modalService: ModalService,
    // private alertService: AlertService,
    private formacaoDuracaoService: FormacaoDuracaoService
  ) {}

  ngOnInit(): void {
    this.activeRoute.queryParams.subscribe((queryParams) => {
      this.currentFilter = queryParams
      this.filterChange.emit()
    })

    this.displayedColumns = ['descricao', 'duracao', 'tipo', 'actions']
  }

  ngAfterViewInit() {
    this.filterChange.subscribe(() => (this.paginator.pageIndex = 0))

    merge(this.paginator.page, this.filterChange)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true
          this.changeDetector.detectChanges()
          return this.formacaoDuracaoService
            .findAllPaginated(this.currentFilter, this.paginator.pageIndex, this.paginator.pageSize)
            .pipe()
        }),
        map((data) => {
          this.isLoadingResults = false
          this.resultsLength = data.totalElements
          return data
        })
      )
      .subscribe((data) => {
        this.dataSource.data = data.content
        this.changeDetector.markForCheck()
      })
  }

  onClickEditarDuracao(formacaoDuracao: FormacaoDuracaoModel) {
    this.router.navigate(['/configuracoes/formacao-duracao', formacaoDuracao.id, formacaoDuracao.tipo.id])
  }
}
